import './InternationalDoctorCard.css';

export const InternationalDoctorCard = ({ avatar, name, onViewProfile }) => {
  return (
    <div className="idc-card">
      <div className="idc-card__avatar-wrap">
        <img src={avatar} alt={name} className="idc-card__avatar" />
      </div>
      <p className="idc-card__name">{name}</p>
      <button className="idc-card__btn" onClick={onViewProfile}>
        View Profile
      </button>
    </div>
  );
};
